import React, { useState } from "react";
import "./ProductCat.css";
import ProductList from "../ProductList/ProductList";
import categories from "../../assets/Data/categories";
import { NavLink } from "react-router";


function ProductCat() {

  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
  };

  return (
    <div className="allpdtCat">
      <div className="maxW">
        <h2>OUR PRODUCTS CATEGORIES</h2>
        <div className="allptMn">
          {categories.map((category, index) => (
            <div className="alptWrp" key={index}>
              <div className="pdtItem">
                <NavLink to={`/Product/${category.catId}`} key={category.catId}>
                  <img src={category.img} alt={`${category.title}-img`} />
                </NavLink>
                <p>{category.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedCategory && <ProductList category={selectedCategory} />}
    </div>
  );
}

export default ProductCat;
